import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/adultComics/collect-active.png';
import _imports_1 from '@/assets/images/adultComics/collect.png';
import _imports_2 from '@/assets/images/adultComics/share2.png';

const _withScopeId = n => (_pushScopeId("data-v-075cb076"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "audltComicsDetails"
};
const _hoisted_2 = {
  class: "head_titles"
};
const _hoisted_3 = {
  class: "top_img_cont"
};
const _hoisted_4 = {
  class: "title text_ellipsis"
};
const _hoisted_5 = {
  class: "CartoonDetail-info"
};

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "·", -1));

const _hoisted_7 = {
  class: "CartoonDetail-tips"
};
const _hoisted_8 = {
  class: "cont"
};
const _hoisted_9 = {
  class: "top_nav"
};
const _hoisted_10 = {
  class: "crmh_cont"
};
const _hoisted_11 = {
  class: "per"
};
const _hoisted_12 = {
  class: "CartoonDetail-WorksPage-statistics"
};

const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "·", -1));

const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "wntj"
}, "为你推荐", -1));

const _hoisted_15 = {
  class: "list"
};
const _hoisted_16 = ["onClick"];
const _hoisted_17 = {
  key: 0,
  class: "item"
};
const _hoisted_18 = {
  class: "crmh_cont"
};
const _hoisted_19 = {
  class: "CartoonDetail-float-bottom"
};
const _hoisted_20 = {
  key: 0,
  src: _imports_0
};
const _hoisted_21 = {
  key: 1,
  src: _imports_1
};

const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "收藏", -1));

const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2
}, null, -1));

const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "分享", -1));

const _hoisted_25 = [_hoisted_23, _hoisted_24];

const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "开始阅读", -1));

const _hoisted_27 = [_hoisted_26];
const _hoisted_28 = {
  class: "details_page"
};
const _hoisted_29 = {
  class: "details_page"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_my_image = _resolveComponent("my-image");

  const _component_van_icon = _resolveComponent("van-icon");

  const _component_comics_item = _resolveComponent("comics-item");

  const _component_van_swipe_item = _resolveComponent("van-swipe-item");

  const _component_comics_content = _resolveComponent("comics-content");

  const _component_van_swipe = _resolveComponent("van-swipe");

  const _component_comics_item_details = _resolveComponent("comics-item-details", true);

  const _component_van_popup = _resolveComponent("van-popup");

  const _component_comics_contents_details = _resolveComponent("comics-contents-details");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [(_openBlock(), _createBlock(_component_my_image, {
    url: $setup.detailsData.image,
    key: $setup.detailsData.image
  }, null, 8, ["url"]))]), _createVNode(_component_van_icon, {
    size: "22",
    name: "arrow-left",
    onClick: $setup.close
  }, null, 8, ["onClick"]), _createElementVNode("span", _hoisted_4, _toDisplayString($setup.detailsData.title), 1), _createElementVNode("div", _hoisted_5, [_createElementVNode("span", null, _toDisplayString($setup.detailsData.comics_status === 1 ? "连载" : "完结") + "," + _toDisplayString($setup.detailsData.nickname), 1), _hoisted_6, _createElementVNode("span", null, _toDisplayString($setup.detailsData.comics_num) + "话", 1), _createElementVNode("span", _hoisted_7, _toDisplayString($setup.detailsData.comics_status === 1 ? "连载中" : "已完结"), 1)])]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", {
    class: _normalizeClass(["top_nav_item", $setup.topNavIndex === 0 ? 'active' : '']),
    onClick: _cache[0] || (_cache[0] = $event => $setup.topNavClick(0))
  }, " 作品 ", 2), _createElementVNode("div", {
    class: _normalizeClass(["top_nav_item", $setup.topNavIndex === 1 ? 'active' : '']),
    onClick: _cache[1] || (_cache[1] = $event => $setup.topNavClick(1))
  }, " 目录 ", 2)]), _createVNode(_component_van_swipe, {
    class: "my-swipe",
    onChange: $setup.change,
    loop: false,
    ref: "swiper",
    "show-indicators": false
  }, {
    default: _withCtx(() => [_createVNode(_component_van_swipe_item, null, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, _toDisplayString($setup.detailsData.content), 1), _createElementVNode("div", _hoisted_12, [_createElementVNode("span", null, _toDisplayString($setup.detailsData.count) + "次浏览", 1), _hoisted_13, _createElementVNode("span", null, _toDisplayString($setup.detailsData.like_num) + "喜欢", 1)]), _hoisted_14, _createElementVNode("div", _hoisted_15, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.similarList, item => {
        return _openBlock(), _createElementBlock("div", {
          class: "item",
          key: item.id,
          onClick: $event => $setup.toDetails(item)
        }, [_createVNode(_component_comics_item, {
          data: item
        }, null, 8, ["data"])], 8, _hoisted_16);
      }), 128)), $setup.similarList.length % 3 === 2 ? (_openBlock(), _createElementBlock("div", _hoisted_17)) : _createCommentVNode("", true)])])]),
      _: 1
    }), _createVNode(_component_van_swipe_item, null, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_18, [_createVNode(_component_comics_content, {
        comics_id: $setup.props.comics_id,
        comics_status: $setup.detailsData.comics_status,
        onStartReading: $setup.startReading,
        onGetComicsDirectory: $setup.getComicsDirectory
      }, null, 8, ["comics_id", "comics_status", "onStartReading", "onGetComicsDirectory"])])]),
      _: 1
    })]),
    _: 1
  }, 8, ["onChange"]), _createElementVNode("div", _hoisted_19, [_createElementVNode("div", {
    onClick: _cache[2] || (_cache[2] = (...args) => $setup.comicsLike && $setup.comicsLike(...args))
  }, [$setup.detailsData.isComicsLike ? (_openBlock(), _createElementBlock("img", _hoisted_20)) : (_openBlock(), _createElementBlock("img", _hoisted_21)), _hoisted_22]), _createElementVNode("div", {
    onClick: _cache[3] || (_cache[3] = (...args) => $setup.toFenxian && $setup.toFenxian(...args))
  }, _hoisted_25), _createElementVNode("div", {
    onClick: _cache[4] || (_cache[4] = $event => $setup.startReading($setup.directoryList[0]))
  }, _hoisted_27)])]), _createVNode(_component_van_popup, {
    show: $setup.showDetailsPopul,
    "onUpdate:show": _cache[5] || (_cache[5] = $event => $setup.showDetailsPopul = $event),
    class: "popup_coentent",
    overlay: false,
    position: "right"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_28, [(_openBlock(), _createBlock(_component_comics_item_details, {
      onClose: $setup.close,
      comics_id: $setup.comics_id,
      key: $setup.key
    }, null, 8, ["onClose", "comics_id"]))])]),
    _: 1
  }, 8, ["show"]), _createVNode(_component_van_popup, {
    show: $setup.showDetailsPopul1,
    "onUpdate:show": _cache[6] || (_cache[6] = $event => $setup.showDetailsPopul1 = $event),
    class: "popup_coentent",
    overlay: false,
    position: "right"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_29, [(_openBlock(), _createBlock(_component_comics_contents_details, {
      comics_id: $setup.props.comics_id,
      comics_status: $setup.detailsData.comics_status,
      comics_directory_id: $setup.comics_directory_id,
      onClose: $setup.close1,
      key: $setup.key1
    }, null, 8, ["comics_id", "comics_status", "comics_directory_id", "onClose"]))])]),
    _: 1
  }, 8, ["show"])]);
}